import React from 'react';

const videos = [
  { id: 'R48BqfPoG7k', title: 'ICASE Conference Highlights 01' },
  { id: 'XafeCCO-6h0', title: 'ICASE Conference Highlights 02' },
  { id: 'QtZYkZA8pYs', title: 'ICASE Conference Highlights 03' },
];

const ICASEVideos = () => (
  <section className="icase-videos" aria-labelledby="icase-videos-title">
    <div className="icase-videos-inner">
      <p className="section-eyebrow">WATCH · DISCOVER · REVISIT</p>
      <h2 id="icase-videos-title">ICASE Video Highlights</h2>
      <div className="icase-title-line" aria-hidden="true" />
      <div className="icase-video-grid">
        {videos.map((video, index) => (
          <article className="icase-video-card" key={video.id}>
            <div className="icase-video-frame">
              <iframe
                src={`https://www.youtube.com/embed/${video.id}`}
                title={video.title}
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
            <div className="icase-video-meta">
              <span>{String(index + 1).padStart(2, '0')}</span>
              <h3>{video.title}</h3>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ICASEVideos;
